import { render, staticRenderFns } from "./PostDish.vue?vue&type=template&id=1841d65e&scoped=true&"
import script from "./PostDish.vue?vue&type=script&lang=js&"
export * from "./PostDish.vue?vue&type=script&lang=js&"
import style0 from "./PostDish.vue?vue&type=style&index=0&id=1841d65e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841d65e",
  null
  
)

export default component.exports